<template>
  <epc-modal-wrapper :active.sync="isModalActive" :title="modalTitle" :width="560" :can-cancel="['escape']">
    <div class="wo-edit-body">
      <work-orders-form ref="refWorkOrderForm"
        :data="workOrder"
        :project-id="projectId"
      />
      <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
    </div>
    <template #footer>
      <button class="epc-modal__button" :disabled="isLoading" @click="isModalActive = false">{{ $t('cancel') }}</button>
      <button class="epc-modal__button epc-modal__button--primary" :disabled="isLoading" @click="save()">
        <b-icon pack="fas" icon="floppy-disk" size="is-small" /> {{ $t('save') }}
      </button>
    </template>
  </epc-modal-wrapper>
</template>

<script>
  import axios from "axios";
  import WorkOrdersForm from './work-orders-form.vue';
  import EpcModalWrapper from '../epc-modal-wrapper.vue';

  import Uppy from '@uppy/core'
  // import AwsS3Multipart from '@uppy/aws-s3-multipart'
  import AwsS3 from '@uppy/aws-s3';
  import store from "~/store";

  export default {

    components: {
      WorkOrdersForm,
      EpcModalWrapper,
    },

    props: {
      projectId: {type: Number, required: true},
    },

    data() {
      return {
        isModalActive: false,
        isLoading: false,
        workOrder: {

        },
        uppy: null, // instancia de la libreria para subir archivos
      }
    },

    watch: {
    },

    created(){
      this.uppy = new Uppy({
        debug: process.env.NODE_ENV === 'development', // activamos debug para development
        autoProceed: false,
        allowMultipleUploads: false,
      })
      .use(AwsS3, {
        shouldUseMultipart: true,
        limit: 3,
        companionUrl: '/api/v2/',
        endpoint: '/api/v2/',
        headers: {
          'Authorization': "Bearer " + store.getters["auth/token"]
        }
      })
      // .on('upload-success', (file, response) => { this.onUploadSuccess(file, response) } )
      .on('upload-success', (file, response) => { // callback deveulto cuando el file ha sido subido correctamente
        console.log('%cEPC-TACKER: '+ '%c file ' + file.data.name + ' subido correctamente', 'background: #5577BB; color: #fff', 'color: #000')
      })
      .on('upload-progress', (file, progesss) => { // callback devuelto con el progreso de subido del archivo
        this.uploadPercentage = parseInt(
          Math.round((progesss.bytesUploaded * 100) / progesss.bytesTotal)
        );
      })
      .on('upload-error', (file, error, response) => { // callback devuelto si ha ocurrido algun error en la subida
        console.error('%cEPC-TACKER: '+ '%c a ocurrido un error al subir el archivo ' + file.data.name, 'background: #5577BB; color: #fff', 'color: #000', error)
      })
    },

    computed: {
      modalTitle() {
        const label = (this.workOrder && this.workOrder.id) ? this.$t('edit') : this.$t('add');
        return `${label} orden de trabajo`;
      },
    },

    methods: {
      show(workOrder) {
        const partner = workOrder.partners && workOrder.partners.length
          ? workOrder.partners[0]
          : null
        // El pivot puede venir de dos formas: directo en la orden cuando se llega
        // desde partner.orders (belongsToMany withPivot flow_id/porcentaje_*), o
        // anidado en partners[0].pivot cuando se llega desde el lado de la orden.
        const pivot = workOrder.pivot || partner?.pivot || {}

        this.workOrder = {
          id: workOrder.id,
          project_id: workOrder.project_id,
          code: workOrder.code,
          description: workOrder.description,
          partner_id: workOrder.partner_id || partner?.id || pivot.partner_id || null,
          flow_id: workOrder.flow_id ?? pivot.flow_id ?? null,
          advance_percentage: workOrder.advance_percentage ?? pivot.advance_percentage ?? null,
          extends_work_order_id: workOrder.extends_work_order_id ?? null,
        }

        this.isModalActive = true
      },

      hide() {
        this.workOrder = {}
        this.isModalActive = false
      },

      async save() {

        let order = this.$refs.refWorkOrderForm.getDataForm()

        if ( !this.validateData(order) )
          return

        let document_id = null
        if ( order.file != null )
          document_id = await this.uploadFile(order.file)

        let body = {
          project_id: this.projectId,
          document_id: document_id,
          code: order.code,
          description: order.description,
          flow_id: order.flow_id || null,
          advance_percentage: order.advance_percentage !== '' && order.advance_percentage != null
            ? order.advance_percentage
            : null,
          extends_work_order_id: order.extends_work_order_id || null,
        }

        if (order.partner_id)
          body.partner_id = order.partner_id

        this.isLoading = true;

        let url = order.id ? `/api/v2/work-orders/${order.id}` : `/api/v2/work-orders`;
        let {data} = await axios.post(url, body)

        if (data.success) {
          this.$notify.success('success_editing')
          this.$emit('reload')
          this.hide()
        } else {
          this.$notify.error('error_saving')
        }
        this.isLoading = false;
      },

      async uploadFile(file) {
        if (file.length == 0) {
          return;
        }

        this.isLoading = true;
        if (file.size / 1024 / 1024 > 1024) {
          this.$notify.warning("document_exceeded_max_size", {
            name: file.name,
          });
        } else {
          let ok = await this.submitFile(file);
          if (ok) {
            this.$notify.success("upload_document_success", {
              files: file.name,
            });
            return ok
          } else {
            this.isLoading = false;
            this.$notify.error("upload_document_error");
            return false;
          }
        }

        // Todos los ficheros subidos
        this.isLoading = false;
        this.$notify.success("upload_document_success", {
          files: 1,
        });
        this.$emit("success");
        return true;
      },

      async submitFile(file) {

        this.uploadPercentage = 0;
        this.cancelRequest = axios.CancelToken.source();

        let form = new FormData();

        // Si el nombre personalizado después del trim tiene contenido usamos ese, y si no pasamos al del fichero
        form.append("original_filename", file.name);
        form.append("entity_type", "workorder");
        form.append("entity_id", this.id);

        form.append("project_id", this.projectId)

        return this.store(file, {})
        .then(async result => {
              // successFul contiene toda la lista de archivos que se han subido
              // para nuestro caso solo consideramos siempre el primero por que enviamos de a uno
              if( result.successful.length > 0 ) {
                let response = result.successful[0].response

                let params = {
                  // uuid: response.uuid,
                  key: response.body.key,
                  // bucket: response.bucket,
                  name: file.name,
                  content_type: file.type,
                  // url: response.url
                }

                form.append("aws_response", JSON.stringify(params));

                let resp = null
                resp = await axios.post("/api/v2/project/" + this.projectId + "/document", form, {
                  cancelToken: this.cancelRequest.token,
                });

                console.log('upload file order: ', resp)

                return resp && resp.data && resp.data.success ? resp.data.document.id : false
              }

              // failed contiene todos los archivos que tubieron fallo al subir
              if (result.failed.length > 0) {
                console.error('Errors:')
                result.failed.forEach((file) => {
                  console.error(file.error)
                })

                return false
              }
        }).catch((error) => {
          console.log('error: ', error)
          return false
        });

      },

      // CUSTOM VAPOR STORE METHOD
      async store(file, options = null) {
        // verificamos si existe algun archivo en la lista de carga de uppy
        // si existe lo eliminamos
        if( this.keyFileUploadCurrent ) {
          this.uppy.removeFile(this.keyFileUploadCurrent);
        }

        if (typeof options.progress === 'undefined') {
            options.progress = () => {};
        }

        this.keyFileUploadCurrent = this.uppy.addFile({
          name: file.name, // file name
          type: file.type, // file type
          data: file, // file blob
          // meta: {
          //   // optional, store the directory path of a file so Uppy can tell identical files in different directories apart.
          //   relativePath: webkitFileSystemEntry.relativePath,
          // },
          source: 'Local',
          isRemote: false,
        });

        // response.data.extension = file.name.split('.').pop()
        return this.uppy.upload()
      },

      validateData(data) {
        let valid = true
        if (data.code == null || data.code == '' ) {
          this.$notify.error("El campo código del pedido es obligatorio")
          valid = false
        }

        const hasPivotFields = data.flow_id
          || (data.advance_percentage !== null && data.advance_percentage !== '')

        if (hasPivotFields && !data.partner_id) {
          this.$notify.error(this.$t('work_order_partner_required_for_flow'))
          valid = false
        }

        return valid
      }
    }
}
</script>

<style scoped lang="scss">
  /* Ancla el b-loading (is-full-page=false) al cuerpo del modal. */
  .wo-edit-body {
    position: relative;
    min-height: 120px;
  }
  .modal-card-body {
    min-height: 180px;
    min-width: 340px;
  }

  .modal-card-foot {
    justify-content: flex-end !important;
  }
</style>
